import React from 'react';
import styled from '@emotion/styled';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import Features from '../components/Features';
import HowItWorks from '../components/HowItWorks';
import Pricing from '../components/Pricing';
import CTA from '../components/CTA';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PageContainer = styled.div`
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  position: relative;
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export default function Home() {
  return (
    <PageContainer>
      <Header />
      <Hero />
      <HowItWorks />
      <Stats />
      <Features />
      <Pricing />
      <CTA />
      <Footer />
    </PageContainer>
  );
}
